export default class Socket {

	url = null
	socket = null
	
	constructor() {
		if(app.key) {
			console.log('*** HOST MODE ***')
			this.url = `wss://share.rocketvox.com/${app.host}?key=${app.key}`
		} else {
			console.log('*** GUEST MODE ***')
			this.url = `wss://share.rocketvox.com/${app.host}`
		}
		this.socket = new WebSocket(this.url)
		this.socket.onopen = () => {}
		this.socket.onclose = e => {}
		this.socket.onmessage = e => {
			const json = JSON.parse(e.data)
			console.log('message', json)
			if(json.type === 'welcome') app.cast.init(json)
			if(json.type === 'guests') app.cast.setGuestCount(json.guests)
			if(json.type === 'sfu_produced') app.cast.sfu_produced(json)
			if(json.type === 'sfu_consumed') app.cast.sfu_consumed(json)
			if(json.type === 'sfu_newProducer') app.cast.sfu_newProducer(json)
			if(json.type === 'sfu_producerStopped') app.cast.sfu_producerStopped(json)
		}
	}

	send(json) {
		this.socket.send(JSON.stringify(json))
	}

}